import type { SubCategoryCode, topTip } from './feature-list'
import type { DeductionItem } from './price-get'

export enum ShowAllBottomButtonType {
  // 查看其他车型
  OTHER_MODEL = 'other_model',
}
export interface AddItem {
  /**
   * 二级类目code
   */
  sub_category_code: string

  /**
   * 添加按钮类型，0添加 1修改
   */
  type: number

  /**
   * 添加按钮文案
   */
  desc: string
}

export interface OptionItem {
  /**
   * 车图
   */
  img_url: string

  /**
   * 名称
   */
  name: string

  /**
   * 价格
   */
  price: number

  /**
   * code
   */
  code: string

  /**
   * 配置类别code
   */
  feature_code: string

  /**
   * 配置类型
   */
  feature_type: string

  /**
   * 所属二级分类
   */
  sub_category_code: SubCategoryCode

  /**
   * 描述
   */
  desc: string

  /**
   *提示描述
   */
  tip_desc?: string

  /**
   * 提示描述url
   */
  tip_url?: string

  /**
   * 人民币前缀
   */
  price_prefix_desc: ''

  /**
   * 表示价格是+还是-的符号
   */
  plus_minus_desc: ''
  /**
   * 0 在售，1 下架
   */
  stop_sale_type: 0 | 1
  // 下架tips文案
  stop_sale_desc: string
  // 下架操作文案
  operate_desc: string
  /**
   * 优惠包选项的提示文案
   */
  select_discount_tip: ''
  /**
   * 优惠包选项的提示图标
   */
  select_discount_tip_icon: string
  /**
   * 优惠包选项的提示图标 宽高比
   */
  select_discount_tip_icon_ratio: string

  /**
   * 原价
   */
  origin_price: number
  /**
   * 单项优惠标签 img
   */
  discount_icon_v2?: string
  /**
   * 单项优惠标签 宽高比
   */
  discount_icon_v2_ratio?: string
}

export interface CategoryItem {
  /**
   * 类目code
   */
  code: CategoryCode

  /**
   * 类目名称
   */
  name: string

  /**
   * 配置
   */
  option_list: OptionItem[]

  /**
   * 添加按钮
   */
  add_button: AddItem
  /**
   * 1 个人，2 企业 为空的时候不展示个人企业的选择ui
   */
  order_person_type: 1 | 2
}

export interface StandardConfigItem {
  name: string
  labels?: {
    title: string
    desc?: string
  }[]
}
/***
 * 最外层配置项数据,用来更新全局配置状态
 */
export interface OutOptionItem {
  code: string
  feature_code: string
  name: string
  price: number
}
export enum TabType {
  Personalization = 'personalization',
  ChoiceStandardConfig = 'choice_standard_config',
  ChoiceCoreConfig = 'choice_core_config',
}
export interface ShowAllTabItem {
  // tab名称
  name: string
  // tab类型 personalization 个性化配置， choice_standard_config 精选标配
  type: TabType
  category_list: CategoryItem[] | StandardConfigItem[]
  // 需要显示折叠文案的位置
  default_show_count?: number
}

export enum OptionStopSaleType {
  Remove = 'remove',
  Modify = 'modify',
}
export interface OperateListItem {
  type: OptionStopSaleType
  option_list: OptionItem[]
  title: string
}
export interface OptionStopSalePopup {
  operate_list: OperateListItem[]
  title?: string
  bottom_tip?: string
  button_name: string
}
/**
 * 配置总览接口
 */
export interface FeatureShowAllRes {
  result_code: string
  data: {
    /**
     * 车图
     */
    img_url: string

    /**
     * 车型code，例如：ES8
     */
    model_code: string

    /**
     * 车款
     */
    generation_code: string

    /**
     * 是否可编辑，0 可编辑，1 不可编辑
     */
    editable: number

    /**
     * 是否可重新配置 0可 1不可
     */
    can_re_config_type?: Number

    /**
     * logo图
     */
    logo_url: string
    /**
     * 多张图
     */
    img_url_list: string[]

    /**
     * 配置类目
     */
    category_list: CategoryItem[]
    /**
     * tab栏
     */
    category_list_tab: ShowAllTabItem[]

    /**
     * 1 个人，2 企业 为空的时候不展示个人企业的选择ui
     */
    order_person_type?: 1 | 2

    /**
     * 总价
     */
    total_price: number
    /**
     * 原价
     */
    origin_price: number

    /**
     * 价格信息
     */
    price_info: {
      total_price: number
      total_price_desc: string
    }

    /**
     * 扣减明细
     */
    deduction_list: DeductionItem[]
    /**
     * 提示信息
     */
    tip_list: string[]
    /***
     * 配置项数据
     */
    option_list: OutOptionItem[]
    /**
     * 配置完成文案
     */
    finish_config_desc: '配置已保存为心愿单'
    /**
     * 心愿单已保存文案
     */
    save_config_desc: '配置已保存为心愿单'
    /**
     * switch_type 3D配置器开关，0 新3D配置器，1 新2D配置器，2 老配置器
     */
    switch_type: number
    /**
     * 电租减价
     */
    baas_deduction_price?: number
    /**
     * 优惠包价格
     */
    discount_price?: number
    /**
     * 国补价格
     */
    subsidy_price?: number
    /**
     * 1 老ES8，2 新ES8，其他为空
     */
    new_version?: number | ''
    /**
     * 分享图片
     */
    share_img_url?: string

    /**
     * 售卖状态，1 在售，2 停售
     */
    model_sale_status: 1 | 2

    /**
     * 停售提示文案
     */
    model_stop_sale_tip: string
    /**
     * 是否可确认订单，0 可确认订单，1 不可确认订单
     */
    can_confirm_order_type: number
    /**
     * 车型名称
     */
    model_name: string
    /**
     * 顶部提示文案
     */
    top_float_tip: string
    /**
     * 停售配置弹窗
     */
    option_stop_sale_popup?: OptionStopSalePopup
    /**
     * 顶部组合包提示文案
     */
    select_optional_pack_tip?: {
      icon: string // 图标
      tip: string // 文案
    }
    // 顶部提示条
    top_tip: topTip
    // 底部按钮列表 这里目前只在车款下架的时候在不可编辑页面用了
    bottom_button_list?: {
      name: string
      type: ShowAllBottomButtonType
      style: string
    }[]
    // 选项提示toast（目前只在电池配置异常的时候会弹）
    option_change_toast?: string
    // 是否配置项有变化
    option_changed?: boolean
    // 是否展示价格更新弹窗
    show_price_update_popup?: boolean
    /**
     * 埋点字段
     */
    frontMetric?: object
    /**
     * 不可选配置项列表
     */
    non_selectable_option_list?: string[]
  }
}
export interface FeatureShowAllOptionItem {
  /**
   * 配置类型code
   */
  feature_code: string

  /**
   * 配置code
   */
  code: string
}
export interface FeatureShowAllReq {
  /**
   * 配置
   */
  option_list?: FeatureShowAllOptionItem[]

  /**
   * 订单号
   */
  order_no?: string

  /**
   * 心愿单号
   */
  conf_no?: string

  /**
   * 1 个人，2 企业 非必传，默认个人
   */
  order_person_type?: 1 | 2

  /**
   * 车型code，例如：ES8
   */
  model_code?: string

  /**
   * 车款code，例如：ES8001
   */
  generation_code?: string
  /**
   * 是否可编辑 0可编辑 1不可编辑
   */
  editable?: Number
  /**
   * 价格展示类型：1. 只展示电池减价和总价
   */
  price_show_type?: number
  // 是否是锁单场景
  from_type?: string
  //入参uniquekey
  uniquekey?: string
}

/**
 * 一级类目 Code 枚举
 */
export enum CategoryCode {
  /**
   * 版本电池
   */
  VersionBattery = 'version_battery',

  /**
   * 外观
   */
  Exterior = 'exterior',

  /**
   * 座舱
   */
  Cockpit = 'cockpit',

  /**
   * 选装
   */
  Optional = 'optional',

  /**
   * NAD
   */
  NAD = 'nad',
  /**
   * discount
   */
  Discount = 'discount',
  /**
   * 价格明细
   */
  Deduction = 'deduction',
  /**
   * 赠送
   */
  Gift = 'gift',

  /**
   * 核心标配
   */
  Additional = 'additional',
}
